import React from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";

const GenrePanel = ({ genre, setGenre, rating, setRating, sortBy, setSortBy }) => {
  const [anchorEl, setAnchorEl] = React.useState(null); 
  const open = Boolean(anchorEl); 
  const id = open ? "simple-popper" : undefined; 

  const displayDD = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget); 
    console.log("DD Clicked");
  };

  const hideDD = (event) => {
    console.log("hideDD Clicked");
    setAnchorEl(null); 
    setSortBy(event.target.value);
  };

  const handleGenre = (value) => {
    let result = [];
    let selectedChips = [...genre];
    let isExist = selectedChips.includes(value);
    console.log(isExist, value);
    
    if (selectedChips.includes("All") && value !== "All") {
      selectedChips = selectedChips.filter((c) => c !== "All");
    } 
    else if (
    (!selectedChips.includes("All") && value === "All") ||
    (!selectedChips.includes("All") && selectedChips.length === 1 && isExist)
    ) {
      selectedChips = ["All"];
    }
    if (isExist) {
      result = selectedChips.filter((s) => s !== value);
    } else {
      result = [...selectedChips, value];
    }
    setGenre(result);
    console.log(result);
  };
  
  const handleRating = (value) => {
    let selectedChips = [...rating];
    console.log(selectedChips);
    let isExist = selectedChips.includes(value);
    if (value !== "Any") {
      // selectedChips = selectedChips.filter((c) => c !== "Any");
      selectedChips = [value]
    } 
    if(isExist || value === "Any") {
      selectedChips = ["Any"]
    }
    console.log(selectedChips, value, isExist);
    setRating(selectedChips);
  };

  return (
    <>
      <Grid container sx={{ backgroundColor: "#282c34" }}>
        <Grid item xs={3}></Grid>
        <Grid item xs={6}>
          <Stack 
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={3}
          >
            <Chip className="genre-btn"
              label="All Genre"
              value="All"
              variant={genre.includes("All") ? "filled" : "outlined"}
              onClick={() => !genre.includes("All") && handleGenre("All")}
            />
            <Chip className="genre-btn"
              label="Education"
              value="Education"
              variant={genre.includes("Education") ? "filled" : "outlined"}
              onClick={() => handleGenre("Education")}
            />
            <Chip className="genre-btn"
              label="Sports"
              value="Sports"
              variant={genre.includes("Sports") ? "filled" : "outlined"}
              onClick={() => handleGenre("Sports")}
            />
            <Chip className="genre-btn"
              label="Comedy"
              value="Comedy"
              variant={genre.includes("Comedy") ? "filled" : "outlined"}
              onClick={() => handleGenre("Comedy")}
            />
            <Chip className="genre-btn"
              label="Lifestyle"
              value="Lifestyle"
              variant={genre.includes("Lifestyle") ? "filled" : "outlined"}
              onClick={() => handleGenre("Lifestyle")}
            />
          </Stack>
        </Grid>

        <Grid item xs={3}>
          <Chip 
            label={sortBy}
            className="sort-select"
            value="Release Date"
            sx={{ backgroundColor: "#fff" }}
            icon={<SwapVertIcon />}
            aria-describedby={id}
            onClick={displayDD}
          />
          
            <Popper id={id} open={open} anchorEl={anchorEl} > 
              <Box 
                sx={{
                  p: 1,
                  bgcolor: "#444D56",
                  color: "#fff",
                  "&:hover": { cursor: "pointer" },
                }}
              >
                <>
                  <option
                    onClick={hideDD} value="Release Date" id="release-date-option">
                    Release Date
                  </option>
                  <option onClick={hideDD} value="View Count" id="view-count-option">
                    View Count
                  </option>
                </>
              </Box>
            </Popper>
          
        </Grid>
      </Grid>

      <Grid container sx={{ backgroundColor: "#282c34" }} p={2}>
        <Grid item xs={3}></Grid>
        <Grid item xs={6}>
          <Stack 
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={3}
          >
            <Chip className="content-rating-btn"
              label="Any age group"
              variant={rating.includes("Any") ? "filled" : "outlined"}
              onClick={() => handleRating("Any")}
            />
            <Chip className="content-rating-btn"
              label="7+"
              variant={rating.includes("7+") ? "filled" : "outlined"}
              onClick={() => handleRating("7+")}
            />
            <Chip className="content-rating-btn"
              label="12+"
              variant={rating.includes("12+") ? "filled" : "outlined"}
              onClick={() => handleRating("12+")}
            />
            <Chip className="content-rating-btn"
              label="16+"
              variant={rating.includes("16+") ? "filled" : "outlined"}
              onClick={() => handleRating("16+")}
            />
            <Chip className="content-rating-btn"
              label="18+"
              variant={rating.includes("18+") ? "filled" : "outlined"}
              onClick={() => handleRating("18+")}
            />
          </Stack>
        </Grid>
        <Grid item xs={3}></Grid>
      </Grid>
    </>
  );
};

export default GenrePanel;
